import React, { useEffect, useState } from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import { UserOutlined } from '@ant-design/icons'
import {Menu, Dropdown, Avatar, Badge, message} from 'antd'
import styles from './style.module.scss'
// import {useAuth0} from "../../../../../contexts/auth0-context";
import { useAuth0 } from '@auth0/auth0-react'
import { PUBLIC_URL } from '../../../../../constants/Config'
import { useData } from '../../../../../contexts/data-context'
import { datasetsService } from '../../../../../services/api/datasets.service'

import CreateSubdomainDialog from '../CreateSubdomain'
import {accountService} from "../../../../../services/api/account.service";
import DisconnectSubdomain from "../DisconnectSubdomain/DisconnectSubdomain";
import getSubdomainTask, { isOwner } from "../../../../../services/utils";
import { ZENDESK_PROVIDER } from 'components/swifteq/Helpdesk/Connect/utils'

const ProfileMenu = () => {
  const [openCreate, setOpenCreate] = useState(false)
  const [openDisconnectModal, setOpenDisconnectModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()

  const [count, setCount] = useState(7)
  const { logout, user, getAccessTokenSilently } = useAuth0()
  const history = useHistory()
  const location = useLocation()

  const { default_dataset, is_customer, init_status, trial_info, trial_usage, hc_analytics_enabled, subdomain, product, setSubdomain, setDefaultDataset } = useData()
  const subdomains = (default_dataset || {}).subdomains || []
  const isViewOnly = user?.['https://www.swifteq.com/role'] === 'view-only';

  useEffect(() => {
    const URLQuery = new URLSearchParams(window.location.search)
    const activeSubdomain = URLQuery.get('subdomain')
    if (activeSubdomain) {
      setSubdomain(activeSubdomain)
    }
  }, [])

  useEffect(() => {
    if (user && window.amplitude && window.amplitude.setUserId && window.amplitude.Identify) {
      window.amplitude.setUserId(user.sub)
      const identifyEvent = new window.amplitude.Identify();
      identifyEvent.set('email', user.email);
      identifyEvent.set('name', user.name);
      identifyEvent.set('status', init_status);
      identifyEvent.set('is_customer', is_customer);
      identifyEvent.set('product', product);
      window.amplitude.identify(identifyEvent);
    }
  }, [user, window.amplitude])

  const do_logout = (e) => {
    e.preventDefault()
    localStorage.removeItem('selectedArticles')
    localStorage.removeItem('activeFilters')
    localStorage.removeItem('missingLanguage')
    localStorage.removeItem('language')
    localStorage.removeItem('filtersArticles');
    logout({ returnTo: PUBLIC_URL })
  }

  const go_to_connect = (e) => {
    e.preventDefault()
    history.push('/init/connect')
  }

  const select_helpcenter = (e, sd) => {
    localStorage.removeItem('selectedArticles')
    localStorage.removeItem('activeFilters')
    localStorage.removeItem('missingLanguage')
    localStorage.removeItem('language')
    setSubdomain(sd.value)

    //redirect to articles from partial translate to make sure the article exists in the selected helpcenter
    const currentPageUrl = location.pathname
    if(currentPageUrl.includes('partial-translate')) {
      history.push('/articles')
    }
    if (window.history.replaceState) {
      const URLQuery = new URLSearchParams(window.location.search);
      URLQuery.set('subdomain', sd.value);
      let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + URLQuery.toString();
      window.history.replaceState({ path: newurl }, '', newurl);
      localStorage.setItem("prevUrl", newurl);
    }
    e.preventDefault()
  }

  const add_helpcenter = (e) => {
    setError(false)
    setOpenCreate(true)
    e.preventDefault()
  }

  const disconnect_helpcenter = (e) => {
    setOpenDisconnectModal(true)
    setError(false)
    e.preventDefault()
  }

  const addCount = () => {
    setCount(count + 1)
  }

  const handleCreateSubdomain = (data) => {
    ; (async () => {
      try {
        setLoading(true)
        const token = await getAccessTokenSilently()
        const rsp = await datasetsService.createSubdomain(token, default_dataset._id, product, data)
        setLoading(false)
        setOpenCreate(false)
        const new_default_dataset = await datasetsService.getOneDataset(
          token,
          default_dataset._id,
          rsp.value,
        )
        setDefaultDataset(new_default_dataset)
        setSubdomain(rsp.value)
      } catch (e) {
        setLoading(false)
        setError(e)
        console.error(e)
      }
    })()
  }

  const disconnectSubdomain = () => {
    ; (async () => {
      try {
        setLoading(true)
        const token = await getAccessTokenSilently()
        const rsp = await datasetsService.disconnectSubdomain(token, default_dataset._id, subdomain)
        const new_default_dataset = await datasetsService.getOneDataset(
          token,
          default_dataset._id,
          subdomains[0].value,
        )
        setDefaultDataset(new_default_dataset)
        setTimeout(()=>{
          setLoading(false)
          setOpenDisconnectModal(false)
          window.location.href = '/'
        },2000)
      } catch (e) {
        setLoading(false)
        setError(e)
        console.error(e)
      }
    })()
  }

  const openBillingPortal = () => {
    ;(async () => {
      try {
        const token = await getAccessTokenSilently()
        const {url} = await accountService.getBillingPortalUrl(token, product)
        window.open(url, '_blank');
      }
      catch (e) {
        console.error(e)
        message.error("Something went wrong. Please try again later or contact us at support@swifteq.com.", 10)
      }
    })()
  }

  const user_role = (user || {})['https://www.swifteq.com/role']
  const is_user_owner = user_role === 'owner' || user_role === 'admin'

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <strong>Hello, {(user || {}).name || 'Anonymous'}</strong>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <div>
          <strong>Email: </strong>
          {(user || {}).email || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      {default_dataset && default_dataset.source === ZENDESK_PROVIDER && (init_status === "ready" || init_status === "expired") && (
        <Menu.SubMenu
          key="help_centers_submenu"
          icon={<i className="fe fe-book-open mr-2" />}
          title="Help Centers"
        >
          <div className={styles.submenuList}>
            {subdomains.map((sd, idx) => (
              <Menu.Item key={idx}>
                <a href="#" onClick={(e) => select_helpcenter(e, sd)}>
                  {sd.value === subdomain && <i className="fe fe-check mr-2" />}
                  {sd.value !== subdomain && <span className="mr-4" />}
                  {sd.value}
                </a>
              </Menu.Item>
            ))}
          </div>

          {!isViewOnly && <Menu.Divider />}
          {!isViewOnly && hc_analytics_enabled && (product === 'hcanalytics' || product === 'hcmanager') &&
            <>
              <Menu.Item>
                <a href="/analytics/data_setup">
                  <i className="fe fe-bar-chart-2 mr-2" />
                  Analytics Setup
                </a>
              </Menu.Item>
              {isOwner(user) && (
                <Menu.Item>
                  <a href="/analytics/feedback_setup">
                    <i className="fe fe-message-square mr-2" />
                    Feedback Form Setup
                  </a>
                </Menu.Item>
              )}
              <Menu.Divider />
            </>
          }
          {!isViewOnly && default_dataset.source === ZENDESK_PROVIDER  &&
          <Menu.Item>
            <a href="#" onClick={add_helpcenter}>
              <i className="fe fe-plus mr-2" />
              Add Help Center
            </a>
          </Menu.Item>}
          {!isViewOnly && subdomains.length > 1 &&
          <Menu.Item>
            <a href="#" onClick={disconnect_helpcenter}>
              <i className="fe fe-minus-circle mr-2" />
              Disconnect Help Center
            </a>
          </Menu.Item>}
        </Menu.SubMenu>
      )}
      {is_user_owner && <Menu.Item>
        <a href="#" onClick={go_to_connect}>
          <i className="fe fe-airplay mr-2" />
          Helpdesk Authorization
        </a>
      </Menu.Item>}
      {is_user_owner &&
      <Menu.Item disabled={!is_user_owner}
      title={(!is_user_owner) ? 'Only an Owner can invite other users' : ''}>
        <a onClick={() => history.push('/invite-users')}>
          <i className="fe fe-users mr-2"/>
          Invite Users
        </a>
      </Menu.Item>}
      {(is_customer && is_user_owner) && (
        <Menu.Item>
          <a onClick={openBillingPortal} target="_blank">
            <i className="fe fe-credit-card mr-2" />
            Manage Billing
          </a>
        </Menu.Item>
      )}
      <Menu.Item>
        <a href="https://support.swifteq.com/hc/en-us" target="_blank" >
          <i className="fe fe-help-circle mr-2" />
          Online Help
        </a>
      </Menu.Item>
      <Menu.Divider />
      {!is_customer && trial_info?.status === "active" && trial_info?.started_at &&
      <>
      {product !== 'hctranslate' && <Menu.Item>
        <span className={"text-warning"}>Trial Days Left: {trial_info?.days_to_expire}</span>
      </Menu.Item>}
      {product === 'hctranslate' && <Menu.Item>
        <a href={"/payment"}>
        <span className={(trial_usage?.hcm_translate?.credits > 0) ? "text-warning": "text-danger"}>Translation Credits: {Math.round(trial_usage?.hcm_translate?.credits) || 0}</span>
        </a>
      </Menu.Item>}
      <Menu.Divider />
      </>}
      <Menu.Item>
        <a href="#" onClick={do_logout}>
          <i className="fe fe-log-out mr-2" />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <>
      <CreateSubdomainDialog
        open={openCreate}
        title={'Add a new Help Center'}
        handleCloseDialog={() => setOpenCreate(false)}
        handleCreateSubdomain={handleCreateSubdomain}
        error={error}
        loading={loading}
      />
      <DisconnectSubdomain
        open={openDisconnectModal}
        title={'Disconnect Help Center'}
        handleCloseDialog={() => setOpenDisconnectModal(false)}
        disconnectSubdomain={disconnectSubdomain}
        activeHelpcenter={subdomain}
        error={error}
        loading={loading}
      />
      <Dropdown overlay={menu} trigger={['click']} onOpenChange={addCount}>
        <div className={styles.dropdown}>
          <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
        </div>
      </Dropdown>
    </>
  )
}

export default ProfileMenu
